import getAppState from 'app-state';

export default () => getAppState<{
    showPrices: boolean;
    shouldShowBvPv: boolean;
}>('priceShow', {
    shouldShowBvPv: false,
    showPrices: false,
});
